import React from 'react';

export const LazyBackgroundTab = React.lazy(() => import(/* webpackChunkName: "tab-background" */ './tabs/BackgroundTab'));
export const LazyWatermarkTab = React.lazy(() => import(/* webpackChunkName: "tab-watermark" */ './tabs/WatermarkTab'));
export const LazyEffectsTab = React.lazy(() => import(/* webpackChunkName: "tab-effects" */ './tabs/EffectsTab'));
export const LazyColorsTab = React.lazy(() => import(/* webpackChunkName: "tab-colors" */ './tabs/ColorsTab'));
export const LazyBlurTab = React.lazy(() => import(/* webpackChunkName: "tab-blur" */ './tabs/BlurTab'));
export const LazyDecorTab = React.lazy(() => import(/* webpackChunkName: "tab-decor" */ './tabs/DecorTab'));
export const LazyTransformTab = React.lazy(() => import(/* webpackChunkName: "tab-transform" */ './tabs/TransformTab'));
export const LazyMiscTab = React.lazy(() => import(/* webpackChunkName: "tab-misc" */ './tabs/MiscTab'));
export const LazySettingsTab = React.lazy(() => import(/* webpackChunkName: "tab-settings" */ './tabs/SettingsTab'));

export const LAZY_TAB_COMPONENTS = {
    background: LazyBackgroundTab,
    watermarks: LazyWatermarkTab,
    effects: LazyEffectsTab,
    colors: LazyColorsTab,
    'blur-sharp': LazyBlurTab,
    decor: LazyDecorTab,
    transform: LazyTransformTab,
    misc: LazyMiscTab,
    settings: LazySettingsTab,
};
